var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"division-management"},[_vm._v(" 部门管理 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }